import { createFileRoute } from "@tanstack/react-router";
import { TopHeader } from "@/components/TopHeader";
import { BottomNavigation } from "@/components/BottomNavigation";
import { CUSTOMER_PLANS, PARTNER_PLANS } from "@/lib/mock-data";
import { Check } from "lucide-react";

export const Route = createFileRoute("/plans")({
  head: () => ({
    meta: [
      { title: "Plans & pricing · Landoo" },
      {
        name: "description",
        content: "Free browsing, contact unlocks and partner plans for property listings.",
      },
      { property: "og:title", content: "Plans & pricing · Landoo" },
      { property: "og:description", content: "Free browsing, contact unlocks and partner plans." },
    ],
  }),
  component: PlansPage,
});

function PlansPage() {
  return (
    <div className="flex min-h-screen flex-col bg-cream/30 pb-20 md:pb-0">
      <TopHeader />
      <main className="mx-auto w-full max-w-5xl flex-1 space-y-8 p-4 md:p-6">
        <Section title="For customers">
          {CUSTOMER_PLANS.map((p) => (
            <PlanCard key={p.name} name={p.name} price={p.price} features={p.features} />
          ))}
        </Section>
        <Section title="For partners">
          {PARTNER_PLANS.map((p) => (
            <PlanCard key={p.name} name={p.name} price={p.price} features={p.features} />
          ))}
        </Section>
        <div className="rounded-2xl border border-dashed border-border bg-cream/60 p-4 text-xs text-muted-foreground">
          Payments are not enabled yet. Pricing shown is a placeholder — no charges will be made.
        </div>
      </main>
      <BottomNavigation />
    </div>
  );
}

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div>
      <h2 className="mb-3 text-lg font-bold text-brown-dark">{title}</h2>
      <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">{children}</div>
    </div>
  );
}

function PlanCard({ name, price, features }: { name: string; price: string; features: string[] }) {
  return (
    <div className="flex flex-col rounded-2xl border border-border bg-card p-5 shadow-soft">
      <div className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">
        {name}
      </div>
      <div className="mt-1 text-2xl font-bold text-brown-dark">{price}</div>
      <ul className="mt-4 space-y-2 text-sm text-brown-dark">
        {features.map((f) => (
          <li key={f} className="flex items-start gap-2">
            <Check className="mt-0.5 h-4 w-4 text-coral" /> {f}
          </li>
        ))}
      </ul>
      <button className="mt-5 rounded-xl bg-brand py-2 text-sm font-semibold text-brown-dark shadow-soft transition hover:brightness-105">
        Choose plan
      </button>
    </div>
  );
}
